import { ContentCopy, SaveOutlined } from "@mui/icons-material";
import {
  Alert,
  Button,
  Card,
  CardContent,
  CardHeader,
  MenuItem,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { PROPOSAL_STATUSES } from "../constants/proposalStatuses";
import { ProposalStatus } from "../types/proposal";

type Props = {
  proposalId: string | null;
  status: ProposalStatus;
  canSave: boolean;
  onStatusChange: (status: ProposalStatus) => void;
  onSave: () => void;
  onCopyNotion: () => void;
};

const ProposalTrackingCard: React.FC<Props> = ({
  proposalId,
  status,
  canSave,
  onStatusChange,
  onSave,
  onCopyNotion,
}) => (
  <Card>
    <CardHeader
      title="Acompanhamento"
      subheader={proposalId ? `Editando ${proposalId}` : "Proposta ainda não salva"}
    />
    <CardContent>
      <Stack spacing={2}>
        <Alert severity="info">
          As propostas ficam armazenadas somente neste navegador por enquanto.
        </Alert>
        <TextField
          select
          fullWidth
          label="Status da proposta"
          value={status}
          onChange={event => onStatusChange(event.target.value as ProposalStatus)}
        >
          {PROPOSAL_STATUSES.map(option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<SaveOutlined />}
            disabled={!canSave}
            onClick={onSave}
          >
            {proposalId ? "Atualizar proposta" : "Salvar proposta"}
          </Button>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<ContentCopy />}
            disabled={!proposalId}
            onClick={onCopyNotion}
          >
            Copiar para Notion
          </Button>
        </Stack>
      </Stack>
    </CardContent>
  </Card>
);

export default ProposalTrackingCard;
